<template>
    <div v-if="ready" class="estates-search-filters">
        <mobile-filters
            v-if="$root.is_mobile"
            :config="config"
            :config_map="config_map"
            :districts="districts_list_event"
            :filters="filters"
            :filter-values="filter_values"
            :geo_data="geo_data"
            :lang="lang"
            :placeholder="placeholder"
            :saveSearchDisable="saveSearchDisable"
            :searchData="searchData"
            :sector="filters.sector"
            :section="section"
            @update-geo="updateGeo"
            @filters-updated="updateSearch"
        />

        <desktop-filters
            v-else
            :count="count"
            :config="config"
            :config_map="config_map"
            :defaultValues="default_values"
            :districts="districts_list_event"
            :fallback="fallback"
            :filters="filters"
            :filter-values="filter_values"
            :geo_data="geo_data"
            :lang="lang"
            :placeholder="placeholder"
            :saveSearchDisable="saveSearchDisable"
            :searchData="searchData"
            :sector="filters.sector"
            :section="section"
            @update-geo="updateGeo"
            @filters-updated="updateSearch"
        />
    </div>
</template>

<script>
import BaseEstatesFields from './BaseFields'
import DesktopSearchFilters from './DesktopSearchFilters'
import MobileSearchFilters from './MobileSearchFilters'

import  { capitalize } from '../../helpers/strings'

export default {
    components: {
        'base-estates-fields': BaseEstatesFields,
        'desktop-filters': DesktopSearchFilters,
        'mobile-filters': MobileSearchFilters,
    },

    props: {
        config: {
            type: Object,
            required: true,
        },

        config_map: {
            type: Object,
            required: true,
        },

        saveSearchDisable: {
            type: Boolean,
            default: false,
        },

        searchData: {
            type: Object,
            required: true,
        },

        types_list: {
            type: Array,
        },

        section: {
            type: String,
            required: true,
        },

        geo_data: {
            type: Object,
            required: true,
        },

        districts_list: {
            type: Array,
            required: false,
        }
    },

    data() {
        return {
            count: 0,
            default_values: {},
            districts: '',
            districts_list_event: this.districts_list,
            fallback: false,
            filters: this.searchData,
            filter_values: null,
            geo: null,
            placeholder: this.searchData.placeholder,
            ready: false,
            results_type: 'geo',
            estate_id: 0
        }
    },

    computed: {
        lang() {
            return this.$root.lang.estates_search_filters
        },
    },

    mounted() {
        if (this.lang) {
            this.fetchFilterValues()
        }

        this.addEvents()

        this.default_values.price = {
            values: this.config.price_list,
            range : {
                box: {
                    min: 0,
                    max: 14
                },
                default: {
                    min: 5,
                    max: this.config.price_list.length - 1
                },
            },
            unit : this.config.unit.price
        },

        this.default_values.surface = {
            values: this.config.surface_list,
            range : {
                default: {
                    min: 0,
                    max: this.config.surface_list.length - 1
                },
            },
            unit : this.config.unit.surface
        }

        window.events.$on('list.update.filters.polygon_id', (event) => {
            this.filters.polygon = event
            this.filters.polygon_id = event
        })

        window.events.$on('list.update.polygon_id', (event) => {
            if (!event) {
                this.filters.polygon = null
                this.filters.polygon_id = null
            }
        })
    },

    methods: {
        addEvents() {
            window.events.$on('search_by_districts', districts => {
                // this.districts = districts.join('|')

                this.updateDistricts(districts)
                // this.updateSearch()
            })

            // window.events.$on('search_by_city', cities => {
            //     cities.region = this.filters.region ?? null
            //     cities.province = this.filters.province ?? null
            //     this.updateCity(cities)
            // })

            window.events.$on('list.heading.count_list', event => {
                this.count = event
            })

            window.events.$on('list.fallback', event => {
                this.fallback = (event) ? true : false
            })

            window.events.$on('list.districts_list', event => {
                this.districts_list_event = event
            })

            window.events.$on('districts.delete', event => {
                this.filters.districts = null
            })

            window.events.$on('list.quarters_list', event => {
                this.quarters_list_event = event
            })

            window.events.$on('quarters.delete', event => {
                this.filters.quarters = null
            })

            window.events.$on('list.update.bounds', event => {
                this.filters.view = event
            })
        },

        fetchFilterValues() {
            let filters = {}

            for (const [filter_name, filter_values] of Object.entries(this.lang.values)) {
                filters[filter_name] = []
                if (typeof filter_values === 'object' && filter_values !== null) {
                    for (const [key, value] of Object.entries(filter_values)) {
                        // if (typeof value === 'object') {
                        //     filters[filter_name + '_' + key] = []
                        //     for (const [key_1, value_1] of Object.entries(value)) {
                        //         filters[filter_name].push({
                        //             id: key_1,
                        //             name: value_1
                        //         })
                        //         filters[filter_name + '_' + key].push({
                        //             id: key_1,
                        //             name: value_1
                        //         })
                        //     }
                        // } else {
                            filters[filter_name].push({
                                id: key.replace('ord_', ''),
                                name: value
                            })
                        // }
                    }
                } else {
                    filters[filter_name].push({
                        id: filter_values,
                        name: filter_name
                    })
                }
            }

            this.filter_values = {
                ...filters,
                types_list: this.types_list
            }
            this.ready = true

            // axios.get('/api/filters/estates', { params: this.search })
            //     .then(({data}) => {
            //         this.filter_values = {
            //             ...data,
            //             types_list: this.types_list
            //         }

            //         this.ready = true
            //     })
            // console.log(this.filter_values)

        },

        updateGeo(data) {
            this.filters.province = null
            this.filters.city = null
            this.filters.cities = null
            this.filters.district = null
            this.filters.districts = null
            this.filters.quarter = null
            this.filters.quarters = null

            this.geo = JSON.stringify(data)

            this['update' + capitalize(data.type)](data)

            this.filters.placeholder = this.placeholder = data.placeholder
            this.filters.polygon_id = null
            this.filters.view = null
            this.filters.zoom = null

            this.$nextTick(() => {
                window.events.$emit('list.unlock.polygons', {})
                window.events.$emit('list.update.filters', this.filters)
            })
        },

        updatePlaceholder(event) {
            this.filters.placeholder = event
        },

        updateRegion(event) {
            this.filters.region = event.id
            this.filters.province = null
            this.filters.city = null
            this.filters.cities = null
            this.filters.districts = null
            this.filters.quarters = null

            window.events.$emit('list.unlock.polygons')
        },

        updateProvince(event) {
            this.filters.region = event.region_id
            this.filters.province = event.id
            this.filters.city = null
            this.filters.cities = null
            this.filters.districts = null
            this.filters.quarters = null

            window.events.$emit('list.unlock.polygons')
        },

        updateCity(event) {
            this.filters.region = event.region_id
            this.filters.province = event.province_id
            this.filters.districts = null
            this.filters.quarters = null

            if (!event.id) {
                this.filters.city = null
                this.filters.cities = null
            }
            else if (event.cities) {
                this.filters.city = null
                this.filters.cities = event.id
            } else {
                this.filters.city = event.id
                this.filters.cities = null
            }

            this.updateSearch()

            window.events.$emit('list.unlock.polygons')
        },

        updateDistricts(event)
        {
            this.filters.region = event.region_id
            this.filters.province = event.province_id
            this.filters.cities = null
            this.filters.city = event.cities ? event.cities[0].id : event.city_id
            this.filters.districts = event.id
            this.filters.quarters = null

            if (event.quarters_id != undefined)
                this.filters.quarters = event.quarters_id

            this.updateSearch()

            window.events.$emit('list.unlock.polygons')
        },

        updateQuarters(event) {
            this.filters.region = event.region_id
            this.filters.province = event.province_id
            this.filters.cities = null
            this.filters.city = event.city_id
            this.filters.districts = event.district_id
            this.filters.quarters = event.id

            this.updateSearch()

            window.events.$emit('list.unlock.polygons')
        },

        updateSearch() {
            if (this.filters.type) {
                // if (!this.lang.values.subsubtypes[this.filters.type]) {
                //     this.filters.subsubtype = null
                // }
                // else
                if (this.searchData.subsubtype) {
                    let types = []
                    this.searchData.subsubtype.split(',').forEach(subsubtype => {
                        if (typeof this.lang.values.subsubtypes[this.filters.type] !== 'undefined' && subsubtype in this.lang.values.subsubtypes[this.filters.type]) {
                            types.push(subsubtype)
                        }
                    })
                    this.filters.subsubtype = types.join(',')
                }
            }
            window.events.$emit('list.update.filters', this.filters)
        }
    },
}

</script>